"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ResizeHandler_exports = {};
__export(ResizeHandler_exports, {
  default: () => ResizeHandler_default
});
module.exports = __toCommonJS(ResizeHandler_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.0078 4C11.0078 3.85677 10.9557 3.73958 10.8516 3.64844C10.7604 3.54427 10.6432 3.49219 10.5 3.49219C10.3568 3.49219 10.2331 3.54427 10.1289 3.64844C10.0378 3.73958 9.99219 3.85677 9.99219 4V9.83984H4.66016L6.37891 8.10156C6.47005 7.9974 6.51562 7.88021 6.51562 7.75C6.51562 7.60677 6.46354 7.48958 6.35938 7.39844C6.26823 7.29427 6.15104 7.24219 6.00781 7.24219C5.8776 7.24219 5.76042 7.29427 5.65625 7.39844L3.21484 9.85938C3.09766 9.97656 3.03906 10.1198 3.03906 10.2891C3.05208 10.4453 3.11068 10.582 3.21484 10.6992L5.65625 13.1016C5.76042 13.2057 5.8776 13.2578 6.00781 13.2578C6.15104 13.2578 6.27474 13.2057 6.37891 13.1016C6.47005 12.9974 6.51562 12.8802 6.51562 12.75C6.51562 12.6068 6.46354 12.4896 6.35938 12.3984L4.62109 10.6602H9.99219V16.5C9.99219 16.6432 10.0378 16.7669 10.1289 16.8711C10.2331 16.9622 10.3568 17.0078 10.5 17.0078C10.6432 17.0078 10.7604 16.9622 10.8516 16.8711C10.9557 16.7669 11.0078 16.6432 11.0078 16.5V10.6602H16.3594L14.6211 12.418C14.5299 12.5091 14.4844 12.6263 14.4844 12.7695C14.4844 12.9128 14.5365 13.0299 14.6406 13.1211C14.7318 13.2122 14.8424 13.2578 14.9727 13.2578C15.1159 13.2578 15.2396 13.2122 15.3438 13.1211L17.7852 10.6406C17.9023 10.5234 17.9544 10.3867 17.9414 10.2305C17.9414 10.0742 17.8893 9.9375 17.7852 9.82031L15.3438 7.41797C15.2396 7.3138 15.1159 7.26172 14.9727 7.26172C14.8424 7.26172 14.7253 7.3138 14.6211 7.41797C14.5299 7.50911 14.4844 7.6263 14.4844 7.76953C14.4844 7.91276 14.5365 8.02995 14.6406 8.12109L16.3594 9.83984H11.0078V4Z",
      fill: "currentColor"
    }
  )
);
const SvgResizeHandler = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ResizeHandler_default = SvgResizeHandler;
